/* eslint-disable @typescript-eslint/no-explicit-any */
import {Injectable} from '@angular/core';
import {AbstractControl} from '@angular/forms';
import {
  alphanumeric_Regex,
  alphanumericSpecialChars_Regex,
  alphanumericWithSpecialCharactersAndDiacritics_Regex,
  letterDiacriticsInput_Regex,
  maxLengthExceeded_Regex,
} from '../constants';

@Injectable({
  providedIn: 'root',
})
export class ValidationService {
  //   1.Accept only characters, diacritics, ' ' and '-' symbol
  //   2. length of the name should be <=256 characters
  charactersDiacriticsWithMaxLimt(control: AbstractControl): {[key: string]: any} | null {
    if (!control.value) {
      return null;
    }

    if (!control.value.match(maxLengthExceeded_Regex)) {
      return {invalidTextInput: true};
    }
    if (control.value.length > 256) {
      return {maxLengthExceeded: true};
    }
    return null;
  }

  //1. Should accept alphanumeric values
  alphanumericCharacters(control: AbstractControl): {[key: string]: any} | null {
    if (!control.value) {
      return null;
    }
    if (!control.value.match(alphanumeric_Regex)) {
      return {invalidAlphanumericInput: true};
    }
    return null;
  }

  //char - includes character, digits and symbols ('.',',' ,'-', '&', ' ' ')
  specialCharacterWithDigits(control: AbstractControl): {[key: string]: any} | null {
    if (!control.value) {
      return null;
    }

    if (!control.value.match(alphanumericSpecialChars_Regex)) {
      return {invalidDigitCharacterInput: true};
    }
    return null;
  }
  //	1. Should accept only letters and diacritics
  charactersWithDiacritics(control: AbstractControl): {[key: string]: any} | null {
    if (!control.value) {
      return null;
    }

    if (!control.value.match(letterDiacriticsInput_Regex)) {
      return {letterDiacriticsInput: true};
    }
    return null;
  }

  alphanumericWithSpecialCharactersAndDiacritics(control: AbstractControl): {[key: string]: any} | null {
    if (!control.value) {
      return null;
    }

    if (!control.value.match(alphanumericWithSpecialCharactersAndDiacritics_Regex)) {
      return {
        invalidAlphanumericWithSpecialCharactersAndDiacriticsInput: true,
      };
    }
    return null;
  }
}
